module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "section-testimonials"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col span-1-of-3"
  }, [_c('blockquote', [_vm._v("\n                比如分析基金，从一张指数图，去分析涨跌缘由，学校的课程只是基础知识普及，但若想真正理解，就必须自己去挖每个拐点的原因，分析国际局势、消费者行为。IHD项目中汇丰银行的专业人士的授课，给出了思维模型，让我在往后的接触中不断地填注并修缮模型。引导你去独立分析思考，最终建成自己的理论体系，这是我认为IHD所给予的最有价值的东西。\n                "), _c('cite', [_c('img', {
    attrs: {
      "src": require("../../assets/resources/img/dwan_lin.png"),
      "alt": "Customer 1 photo"
    }
  }), _vm._v("Dawn LIN")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col span-1-of-3"
  }, [_c('blockquote', [_vm._v("\n                中午12点，我们倒数第三个出场。台上的我们镇定自若，一串串流利的英语脱口而出。最后，在小组勇夺第二的同时，自己十分意外的收获到了一份实习offer，也为自己的七天之旅画上了一个圆满的句号。我收获了友谊、收获了知识，同时，也在一次次的准备中，使自己的逻辑、条理更加清晰。当然，也又一次的克服了自己怯场、和胆小的毛病，让自己又经历了一次成长！\n                "), _c('cite', [_c('img', {
    attrs: {
      "src": require("../../assets/resources/img/mary_ma.png"),
      "alt": "Customer 2 photo"
    }
  }), _vm._v("Mary MA")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col span-1-of-3"
  }, [_c('blockquote', [_vm._v("\n                项目中的每一个Project，都是时限短、强度大。在学校需要一两个星期完成的，在这里只有一两天的时间，然而每个小组都可以完成任务，质量也和平时在学校里做的相当。每次回想起来都会觉得不可思议，同时也需要反思，平时工作效率是否太低，多任务并行下如何高效处理，是IHD教给我的重要一课。\n                "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('cite', [_c('img', {
    attrs: {
      "src": require("../../assets/resources/img/yin_huang.png"),
      "alt": "Customer 3 photo"
    }
  }), _vm._v("Yin HUANG")])])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('h2', [_vm._v("Our reputations")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-fc131a92"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/sections/Testimonials.vue
// module id = 110
// module chunks = 0